import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './index.css';
import MainApp from './routes/MainApp';
import { ErrorBoundary } from './components/Common/ErrorBoundary';


const router = createBrowserRouter([
  {
    path: "/*",
    element: (
      <ErrorBoundary>
        <MainApp />
      </ErrorBoundary>
    ),
    // optional: also handle route-level render/loader errors
    // errorElement: <ErrorFallback />
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
